import {
  EXPLORA_EBIKE_FESTIVAL_EVENT_URL,
  EXPLORA_EBIKE_FESTIVAL_SLUG,
  exploraEbikeFestivalLpContent,
} from "@/content/partners/explora-ebike-festival"
import {
  MONKEYS_FEST_RIDE_2026_EVENT_URL,
  MONKEYS_FEST_RIDE_2026_SLUG,
  monkeysFestRide2026LpContent,
} from "@/content/partners/monkeys-fest-ride-2026"

export type EventPartnershipPlatform = "race_result" | "sympla"

export type EventPartnershipOffer = {
  slug: string
  eventName: string
  eventUrl: string
  platform: EventPartnershipPlatform
  platformName: string
  amountBrl: number
  utmCampaign: string
}

export const EVENT_PARTNERSHIP_OFFERS: Record<string, EventPartnershipOffer> = {
  [MONKEYS_FEST_RIDE_2026_SLUG]: {
    slug: MONKEYS_FEST_RIDE_2026_SLUG,
    eventName: monkeysFestRide2026LpContent.eventName,
    eventUrl: MONKEYS_FEST_RIDE_2026_EVENT_URL,
    platform: "race_result",
    platformName: monkeysFestRide2026LpContent.platformName,
    amountBrl: 100,
    utmCampaign: MONKEYS_FEST_RIDE_2026_SLUG,
  },
  [EXPLORA_EBIKE_FESTIVAL_SLUG]: {
    slug: EXPLORA_EBIKE_FESTIVAL_SLUG,
    eventName: exploraEbikeFestivalLpContent.eventName,
    eventUrl: EXPLORA_EBIKE_FESTIVAL_EVENT_URL,
    platform: "sympla",
    platformName: exploraEbikeFestivalLpContent.platformName,
    amountBrl: 100,
    utmCampaign: EXPLORA_EBIKE_FESTIVAL_SLUG,
  },
}

export function getEventPartnershipOffer(
  slug: string | null | undefined,
): EventPartnershipOffer | null {
  if (!slug) return null
  return EVENT_PARTNERSHIP_OFFERS[slug.trim().toLowerCase()] ?? null
}

export function isEventPartnershipSlug(slug: string | null | undefined): boolean {
  return getEventPartnershipOffer(slug) !== null
}

export function listEventPartnershipOffers(): EventPartnershipOffer[] {
  return Object.values(EVENT_PARTNERSHIP_OFFERS)
}
